// extracted by mini-css-extract-plugin
export default {"FloatingButton":"FloatingButton_FloatingButton__Wcsa+","FloatingButtonLarge":"FloatingButton_FloatingButtonLarge__AZGiE"};